import { getdatatype } from "@project/components/fbMenuRightFn"
import { list_url } from "@project/sharedcomponents/apiURL"
import { getAxiosCancelToken, getCatchErrorMessage, isblank, setAxiosCancelToken } from "@project/sharedcomponents/utilityFunctions"
import axios from "axios"
import { getAccountSitesetting, getheaders, getMenuData, handleResponse, postErrorOnException } from "../Lib/commonfunctions"
import {
  CUSTOM_FIELD_LOCAL_SEARCH,
  CUSTOM_FIELD_SERVICE_CLEAR,
  CUSTOM_FIELD_SERVICE_FAIL,
  CUSTOM_FIELD_SERVICE_START,
  CUSTOM_FIELD_SERVICE_SUCCESS,
  LAST_PAGE_UPDATE,
  LOADING_STATE,
  SNACKBAR_STATE,
} from "./types"

export const customField_data_clear = () => {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_FIELD_SERVICE_CLEAR,
    })
  }
}

export const local_search_customField = ({ search_text }) => {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_FIELD_LOCAL_SEARCH,
      search_text: search_text,
    })
  }
}

export const fetch_customField_data = ({ rowsPerPage, page, order, orderBy, search_text, other_type }) => {
  const pagination_size = getAccountSitesetting("pagination_size")
  if (isblank(rowsPerPage)) {
    rowsPerPage = pagination_size
  }

  return (dispatch) => {
    if (typeof getAxiosCancelToken() != typeof undefined) {
      getAxiosCancelToken().cancel("Operation canceled due to new request.")
    }
    // save the new request for cancellation
    setAxiosCancelToken(axios.CancelToken.source())
    dispatch({ type: CUSTOM_FIELD_SERVICE_START })
    dispatch({ type: LOADING_STATE, state: true })
    let data = new FormData()
    data.append("offset", page * rowsPerPage)
    data.append("type", "customField")
    data.append("limit", rowsPerPage)
    data.append("sort_order", order)
    data.append("sort_by", orderBy)
    data.append("search_text", search_text)
    data.append("other_type", other_type)

    axios.defaults.headers.common = getheaders()
    axios({
      method: "post",
      url: list_url({ type: "custom_field" }),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },

      data: data,
      cancelToken: getAxiosCancelToken().token,
    })
      .then((response) => handleResponse(response, dispatch))
      .then((response) => {
        if (response.data.meta.code === 401) {
          customFieldServiceFail({ dispatch, response: response.data.meta.message, rowsPerPage, page, order, orderBy, search_text })
          dispatch({ type: LOADING_STATE, state: false })
        } else {
          customFieldServiceSuccess({ dispatch, user: response, rowsPerPage, page, order, orderBy, search_text })
          dispatch({
            type: LAST_PAGE_UPDATE,
            lasttype: "customField",
            lastaction: "list",
            lasttime: new Date().getTime(),
            lastdata: "",
          })
          dispatch({ type: LOADING_STATE, state: false })
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          dispatch({ type: LOADING_STATE, state: false })
        } else {
          postErrorOnException(error)
          customFieldServiceFail({ dispatch, response: getCatchErrorMessage(error), rowsPerPage, page, order, orderBy, search_text })
          dispatch({ type: LOADING_STATE, state: false })
        }
      })
  }
}

const customFieldServiceSuccess = ({ dispatch, user, rowsPerPage, page, order, orderBy, search_text }) => {
  dispatch({
    type: CUSTOM_FIELD_SERVICE_SUCCESS,
    payload: user,
    rowsPerPage: rowsPerPage,
    page: page,
    order: order,
    orderBy: orderBy,
    search_text: search_text,
    getdatatype: getdatatype(getMenuData),
  })
}

const customFieldServiceFail = ({ dispatch, response, rowsPerPage, page, order, orderBy, search_text }) => {
  dispatch({
    type: SNACKBAR_STATE,
    payload: true,
    message: response,
    snackbarType: "error",
  })

  dispatch({
    type: CUSTOM_FIELD_SERVICE_FAIL,
    payload: response,
    rowsPerPage: rowsPerPage,
    page: page,
    order: order,
    orderBy: orderBy,
    search_text: search_text,
  })
}
